export const ListingAvailability = ({ shouldCheckIn = false, isEnabled = false } = {}) => ({
  // deprecated defaultActiveDays in favor of daysExtended on /activate endpoint
  shouldCheckIn: Boolean(shouldCheckIn),
  isEnabled: Boolean(isEnabled),
});
